import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { useFooterAnimationContext } from '../../../context/FooterAnimationContext/index.js';
import { useThemeContext } from '../../../context/ThemeContext/ThemeContext.js';
import '@dynamic-labs/sdk-api';
import '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../../context/ViewContext/ViewContext.js';
import { ReactComponent as SvgArrowDown } from '../../../shared/assets/arrow-down.js';
import '../../../utils/constants/colors.js';
import '../../../shared/consts/index.js';
import { Skeleton } from '../../../components/Skeleton/Skeleton.js';
import { classNames } from '../../../utils/functions/classNames/classNames.js';
import { Typography } from '../../../components/Typography/Typography.js';
import '../../../context/DynamicContext/DynamicContext.js';
import '../../../components/ShadowDOM/ShadowDOM.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../config/ApiEndpoint.js';
import '../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../context/MockContext/MockContext.js';
import '../../../context/CaptchaContext/CaptchaContext.js';
import '../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../../components/IconButton/IconButton.js';

const Footer = ({ heading, icon, projectSettings }) => {
    const { theme } = useThemeContext();
    const { isFooterExpanded, setIsFooterExpanded } = useFooterAnimationContext();
    const borderClassName = useMemo(() => {
        if (isFooterExpanded) {
            return 'footer--border-bottom';
        }
        return 'footer--border-top';
    }, [theme, isFooterExpanded]);
    const arrowClassName = useMemo(() => {
        const classes = ['footer__arrow'];
        if (isFooterExpanded) {
            classes.push('footer__arrow--open');
        }
        return classes.join(' ');
    }, [isFooterExpanded]);
    return (jsx("div", Object.assign({ onClick: () => projectSettings && setIsFooterExpanded(!isFooterExpanded), className: classNames('footer', borderClassName), role: 'button', "data-testid": 'wallet-footer-container' }, { children: jsxs("div", Object.assign({ className: 'footer__container' }, { children: [jsxs("div", Object.assign({ className: 'footer__container--heading' }, { children: [!projectSettings ? (jsx(Skeleton, { className: 'footer__skeleton--icon' })) : (Boolean(icon) && (jsx("div", Object.assign({ className: 'footer__container--icon', "data-testid": 'wallet-footer-icon' }, { children: icon })))), jsx(Typography, Object.assign({ as: 'h3', variant: 'body_normal' }, { children: !projectSettings ? (jsx(Skeleton, { className: 'footer__skeleton--heading' })) : (heading) }))] })), projectSettings && jsx(SvgArrowDown, { className: arrowClassName })] })) })));
};

export { Footer };
